import {FeedbackReducerActionType, useFeedbackDispatch} from "../utils/FeedbackContext";
import {useEffect, useState} from "react";
import {getTransactionTypes} from "../api/RestCallHelper";
import {useHistory, useLocation} from "react-router-dom";

export default function useFetchTransactionTypes(dropdownOpen) {

    let history = useHistory();
    let location = useLocation();

    const dispatch = useFeedbackDispatch();

    const [data, setData] = useState([]);
    const loading = dropdownOpen && data.length === 0;

    const close = (event, reason) => {
        console.log("In useFetchRelationshipTypes close callback");
        if (reason === 'clickaway') return;

        dispatch({type: FeedbackReducerActionType.CLOSE_FEEDBACK});
    };

    useEffect(() => {
        let active = true;

        if (!loading) {
            return undefined;
        }
        getTransactionTypes(setData, active, dispatch, close, history, location);

        return () => {
            active = false;
        };
    }, [loading]);

    return [data, loading]
}